import { render, staticRenderFns } from "./formattedJobType.vue?vue&type=template&id=267edfe0"
import script from "./formattedJobType.vue?vue&type=script&lang=js"
export * from "./formattedJobType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports